$(document).ready(function () {
    handleChangeSizeHeader();
    handleAnimationMenuIcon();
    handleExtendChildMenuMobile();
    handleResize();
    handleShowMenuMobile();
});

function handleResize() {
    $(window).resize(function () {
        if ($(window).width() > 992) {
            $('.icon-toggle-menu-mb').removeClass('change');
            $('.menu-mobile-box').removeClass('--show');
        }
    });
}

function handleShowMenuMobile() {
    $('.icon-toggle-menu-mb').on('click', function () {
        if ($(this).hasClass('change')) {
            $('.menu-mobile-box').addClass('--show')
        } else {
            $('.menu-mobile-box').removeClass('--show')
        }
    })
}

function handleExtendChildMenuMobile() {
    // $('.menu-mobile__item, .menu-mobile__item--icon').on('click', function () {
    $('.menu-mobile__item, .menu-mobile__item--icon').on('click', function () {
        let childMenuElement = $(this).find('.child-menu-mobile')
        if (!$(this).attr('class').includes('menu-mobile__item')) {
            childMenuElement = $(this).parent().find('.child-menu-mobile')
        }

        const menuIcon = $(this).hasClass('.menu-mobile__item--icon') ? $(this) : $(this).find('.menu-mobile__item--icon');

        if ($(this).find('.child-menu-mobile').length > 0) {
            if (menuIcon.hasClass('--rotate')) {
                menuIcon.removeClass('--rotate');
                childMenuElement.removeClass('--show')
            } else {
                menuIcon.addClass('--rotate');
                childMenuElement.addClass('--show')
            }
        }
    });
}

function handleAnimationMenuIcon() {
    $('.icon-toggle-menu-mb').on('click', function () {
        $('.icon-toggle-menu-mb').toggleClass("change");
        $('.mb-menu-content').toggleClass('--show');
        $('.header__mb-menu--menu-icon-open').toggleClass('--hidden');
        $('.header__sub-mb-menu--menu-icon-open').toggleClass('--hidden');
        $('.header__mb-menu--menu-icon-close').toggleClass('--hidden');
        $('.header__sub-mb-menu--menu-icon-close').toggleClass('--hidden');
    })
}

function handleChangeSizeHeader() {
    $(window).scroll(function () {
        var scrollTopPosition = $(this).scrollTop(); // Lấy vị trí hiện tại của scroll

        changeSizeHeader(scrollTopPosition)
    })

    changeSizeHeader($(window).scrollTop())
}

function changeSizeHeader(scrollTopPosition) {
    if (scrollTopPosition > 4) {
        $('header').addClass('--small');
        $('.header__pc--logo').addClass('--small');
        $('.page-content').addClass('--pushed');
    } else {
        $('header').removeClass('--small');
        $('.header__pc--logo').removeClass('--small');
        $('.page-content').removeClass('--pushed');
    }
}
